import { call, put, debounce } from 'redux-saga/effects';
import {
  availableCabinsRequest,
  availableCabinsSuccess,
  availableCabinsFailure,
  getSpecificCabinSuccess,
} from '../../slices/cruise';
import axios from '../axiosConfig';

const queryString = require('query-string');

// action.payload something like this
// { itineraryId: '123123',
//   cabinCategoryCode: 'PNS',
//   cabinCategoryRateOptionCode: 'BESTRATE'
// }
function* availableCabinsWorker(action) {
  try {
    const searchObj = {
      ...action.payload,
    };

    if (action.payload.cabinNumber) {
      searchObj.cabinNumber = action.payload.cabinNumber;
      searchObj.resultno = action.payload.resultno;
      searchObj.gradeno = action.payload.gradeno;
      searchObj.sessionKey = action.payload.sessionKey;
    }

    const { customerEmail, ...safeSearchObj } = searchObj;

    const config = {
      method: 'get',
      url: `cruises/getAvailableCabins?${queryString.stringify(safeSearchObj, { skipNull: true })}`,
    };

    const response = yield call(axios, config);

    if (response.data) {
      if (response.data.cabins.length === 0) throw new Error();
      if (action.payload.cabinNumber) {
        yield put(
          getSpecificCabinSuccess({
            cabin: response.data && response.data.cabins && response.data.cabins[0],
          }),
        );
      } else {
        yield put(availableCabinsSuccess(response.data));
      }
    } else throw new Error();
  } catch (error) {
    // Initialize empty errors object, to show no cabins error
    if (action.payload.cabinNumber) {
      yield put(getSpecificCabinSuccess({}));
    } else {
      yield put(availableCabinsFailure({ errors: [{ description: '' }] }));
    }
  }
}

function* availableCabinsWatcher() {
  yield debounce(50, availableCabinsRequest.toString(), availableCabinsWorker);
}

export default availableCabinsWatcher;
